import { toast } from "@/ui-plus/sonner";

export const showTurnstile = async function (sitekey: string): Promise<string> {
    return new Promise(async (resolve, reject) => {
        let retryCount = 1;
        const maxRetries = 2;

        const overlay = document.createElement('div');
        // Radix dialog sets pointer-events:none on body; layer must opt back in to receive clicks.
        overlay.style.cssText = 'position:fixed;inset:0;z-index:2147482990;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.8);pointer-events:auto';

        const card = document.createElement('div');
        card.style.cssText = 'background:var(--card, #fff);border-radius:8px;padding:24px;max-width:400px;width:100%;box-shadow:0 25px 50px -12px rgba(0,0,0,0.25);text-align:center;pointer-events:auto';

        const title = document.createElement('div');
        title.style.cssText = 'font-size:14px;margin-bottom:16px;color:var(--card-foreground, #111)';
        title.textContent = '';

        const turnstileWrapper = document.createElement('div');
        turnstileWrapper.style.cssText = 'display:flex;justify-content:center;margin:16px 0';

        card.appendChild(title);
        card.appendChild(turnstileWrapper);
        overlay.appendChild(card);
        document.body.appendChild(overlay);

        const titleTimeout = setTimeout(() => {
            title.textContent = 'Please verify by checking the box below';
        }, 2000);

        const cleanup = () => {
            clearTimeout(titleTimeout);
            overlay.remove();
        };

        const renderTurnstile = () => {
            turnstileWrapper.innerHTML = '<div class="cf-turnstile"></div>';
            const randomId = `turnstile${(Math.floor(Math.random() * 1e15)).toString(36)}`;

            (window as any)[randomId] = function () {
                try {
                    if ((window as any).turnstile) {
                        (window as any).turnstile.render(turnstileWrapper.querySelector('.cf-turnstile')!, {
                            sitekey: sitekey,
                            "error-callback": function (error: any) {
                                const errorStr = error.toString();
                                if (
                                    (errorStr.startsWith("300") || errorStr.startsWith("600")) &&
                                    retryCount < maxRetries
                                ) {
                                    toast.info("captcha error, retrying..." + errorStr);
                                    retryCount++;
                                    console.log(`Turnstile error ${errorStr}. Retrying... (${retryCount}/${maxRetries})`);
                                    setTimeout(() => {
                                        renderTurnstile();
                                    }, 300);
                                } else {
                                    setTimeout(() => {
                                        toast.error("captcha error, refresh the page and try again");
                                    }, 1000);
                                    cleanup();
                                    reject(error);
                                }
                            },
                            callback: function (token: string) {
                                cleanup();
                                resolve(token);
                            },
                        });
                    }
                } catch (e) {
                    console.log("error window.turnstile.render");
                    console.log(e);
                    cleanup();
                    reject(e);
                }
            };

            const script = document.createElement('script');
            script.src = `https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=${randomId}`;
            document.head.appendChild(script);
            setTimeout(() => {
                script.remove();
            });
        };

        renderTurnstile();
    });
}
